import * as React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { Captcha } from './formComponents/CaptchaComponent';
import { AdditionalFormFields } from './formComponents/AdditionalFormFields';
import { AccountDetailsForm } from './formComponents/AccountDetailsForm';
import { RequiredFormDataWithCaptcha } from './formTypes';
import { Success } from '../successComponent/Success';
import { useTranslation } from 'react-i18next';

export const Form = () => {
  const reRef = React.useRef<ReCAPTCHA>();
  const [initData, setInitData] = React.useState<{ clientId: string; siteKey: string }>();
  const [requiredData, setRequiredData] = React.useState<RequiredFormDataWithCaptcha | null>(null);
  const [isFinished, setIsFinished] = React.useState(false);

  const { t } = useTranslation();

  const init = React.useCallback(async () => {
    const res = await window.fetch('/Registration', {
      method: 'GET',
      mode: 'cors'
    });

    const initData: { SITE_KEY: string; CLIENT_ID: string } = await res.json();
    setInitData({
      clientId: initData.CLIENT_ID,
      siteKey: initData.SITE_KEY
    });
  }, []);

  React.useEffect(() => {
    init();
  }, [init]);

  const currentFormProgression = React.useMemo(() => {
    if (isFinished) {
      return {
        component: <Success />,
        title: 'controllEmail',
        text: 'finished'
      };
    }
    if (requiredData) {
      return {
        component: (
          <AdditionalFormFields
            setIsFinished={setIsFinished}
            requiredData={requiredData}
            setRequiredData={setRequiredData}
            captchaRef={reRef}
          />
        ),
        title: 'formInProgress',
        text: 'additional'
      };
    }
    return {
      component: (
        <AccountDetailsForm
          initData={initData}
          captchaRef={reRef}
          setRequiredData={setRequiredData}
        />
      ),
      title: 'formInProgress',
      text: 'req'
    };
  }, [isFinished, requiredData, initData, reRef]);

  return (
    <>
      <Box
        sx={{
          marginTop: '0.5rem',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Card
          sx={{
            maxWidth: '36rem',
            paddingBottom: '0.5rem',
            position: 'relative',
            border: 'none',
            boxShadow: 'none',
            backgroundColor: 'transparent',
            zIndex: 2
          }}
        >
          <CardContent>
            <Typography margin="auto" variant="h1" fontWeight="bold" mb="0.2rem">
              {t(`title.${currentFormProgression.title}`)}
            </Typography>
            <Typography fontSize={14} sx={{ maxWidth: '100%', mx: 'auto', my: '1.3rem' }} textAlign="center" color="text">
              {currentFormProgression.text ? t(`infoText.${currentFormProgression.text}`) : ''}
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                maxWidth: '22rem',
                margin: 'auto'
              }}
            >
              {currentFormProgression.component}
            </Box>
            {initData?.siteKey && <Captcha siteKey={initData?.siteKey} reRef={reRef as React.Ref<ReCAPTCHA>} />}
          </CardContent>
        </Card>
      </Box>
    </>
  );
};
